import { render, staticRenderFns } from "./RuleTemplate.vue?vue&type=template&id=ce539858"
import script from "./RuleTemplate.vue?vue&type=script&lang=js"
export * from "./RuleTemplate.vue?vue&type=script&lang=js"
import style0 from "./RuleTemplate.vue?vue&type=style&index=0&id=ce539858&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports